import script from "./ResultTestTile.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultTestTile.vue?vue&type=script&setup=true&lang=js"

import "./ResultTestTile.vue?vue&type=style&index=0&id=564cacdd&lang=scss&scoped=true"

import exportComponent from "/Users/uguraslan/work/ljs/tools/strike/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564cacdd"]])

export default __exports__